const Packery = require('packery');

const $ = jQuery.noConflict();

const mosaics = document.querySelectorAll('.client-testimonials__grid');

const addMosaic = () => {
	if (mosaics.length) {
		mosaics.forEach((mosaic) => {
			// set the initial maxHeight
			mosaic.style.maxHeight = '455px';

			// eslint-disable-next-line no-unused-vars
			const pckry = new Packery(mosaic, {
				itemSelector: '.client-testimonials__grid-item',
				gutter: 30,
			});
			// check height of grid.
			checkOverlay(mosaic);
		});

		$('.client-testimonials__btn').on('click', function (e) {
			const closestGrid = e.target
				.closest('.client-testimonials')
				.querySelector('.client-testimonials__grid');
			const closestGridHeight = parseInt(
				closestGrid.style.maxHeight.replace('px', '')
			);
			closestGrid.style.maxHeight = closestGridHeight + 600 + 'px';
			checkOverlay(closestGrid);
		});
	}
};

const checkOverlay = (theMosaic) => {
	const mosaicHeight = parseInt(theMosaic.style.height.replace('px', ''));
	const currentMaxHeight = parseInt(
		theMosaic.style.maxHeight.replace('px', '')
	);
	const parentGrid = theMosaic.closest('.client-testimonials');

	if (currentMaxHeight <= mosaicHeight) {
		if (!parentGrid.classList.contains('active')) {
			parentGrid.classList.add('active');
		}
	} else {
		parentGrid.classList.remove('active');
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {},
	loaded() {
		addMosaic();
	},
	resized() {
		// addMosaic();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
